/**
 * メディアタイプ判定ユーティリティ
 */

/**
 * ファイルが動画かどうかを判定する
 */
export function isVideoFile(filename: string, mimeType?: string): boolean {
  // MIMEタイプでの判定
  if (mimeType?.startsWith("video/")) {
    return true;
  }

  // 拡張子での判定
  const ext = filename.split(".").pop()?.toLowerCase();
  const videoExtensions = [
    "mp4",
    "webm",
    "mov",
    "avi",
    "mkv",
    "flv",
    "wmv",
    "m4v",
  ];
  return videoExtensions.includes(ext || "");
}

/**
 * Attachmentが動画かどうかを判定する
 */
export function isVideoAttachment(attachment: {
  originalUrl: string;
  mime: string;
  kind?: string;
}): boolean {
  return (
    attachment.kind === "video" ||
    isVideoFile(attachment.originalUrl, attachment.mime)
  );
}

/** サムネイル右上に表示するバッジ種別 */
export type ThumbnailBadge = "video" | "oekaki" | null;

/**
 * サムネイル(カタログ/スレ画)右上に表示するバッジ種別を判定する。
 *
 * isOekakiはpresign時のクライアント自己申告値であり、サーバーは真正性を検証しない
 * (Issue #45)。動画判定は実体検査済みのkind/mimeに基づくため、両者が矛盾して
 * 真の場合(自己申告の悪用や不整合データ)は動画バッジを優先し、お絵かきバッジと
 * 競合表示しない。
 */
export function resolveThumbnailBadge(
  attachment:
    | {
        originalUrl: string;
        mime: string;
        kind?: string;
        isOekaki?: boolean;
      }
    | null
    | undefined,
): ThumbnailBadge {
  if (!attachment) {
    return null;
  }
  if (isVideoAttachment(attachment)) {
    return "video";
  }
  if (attachment.isOekaki) {
    return "oekaki";
  }
  return null;
}
